export default __webpack_public_path__ + "static/media/js.4d11b7ee.jpg";